const LEGACY_CHECK_COMPATIBILITY = {
  ADMIN: ["SERALOGIN_ADMIN"],
  DIRECTOR: ["SERALOGIN_MANAGEMENT"],
  MANAGEMENT: ["SERALOGIN_MANAGEMENT"],
  GENERAL_MANAGEMENT: ["SERALOGIN_MANAGEMENT"],
  ADMIN_BANNER: ["SERALOGIN_BANNER_EDITOR"],
  DOFA_EDITOR_BANNER_MANAGER: ["SERALOGIN_BANNER_EDITOR"],
  ACCOMPANIMENT_LEADER: ["ACCOMPANIMENT_EDITOR"],
  ACCOMPANIMENT_COORDINADOR: ["ACCOMPANIMENT_EDITOR"],
  ACCOMPANIMENT_MODULE_ACCESS: ["ACCOMPANIMENT_EDITOR"],
  BIOMEDICAL_MODULE_VIEWER: ["BIOMEDICAL_VIEWER", "BIOMEDICAL_MODULE_ADMIN"],
  BIOMEDICAL_MODULE: [
    "BIOMEDICAL_OPERATOR",
    "BIOMEDICAL_INSPECTION_APPROVER",
    "BIOMEDICAL_MODULE_ADMIN",
  ],
  EDIT_INDICATORS_ANALYSIS: ["BIOMEDICAL_DASHBOARD_ANALYSIS_EDITOR"],
  EDIT_INVENTORY: ["BIOMEDICAL_OPERATOR", "BIOMEDICAL_INVENTORY_ADMIN"],
  BIOMEDICAL_EQUIPMENT_ADMINISTRATOR: ["BIOMEDICAL_INVENTORY_ADMIN"],
  EDIT_INVENTORY_RESUME: [
    "BIOMEDICAL_OPERATOR",
    "BIOMEDICAL_EQUIPMENT_RESUME_ADMIN",
  ],
  EDIT_INVENTORY_INSPECTION: ["BIOMEDICAL_OPERATOR", "BIOMEDICAL_INSPECTION_ADMIN"],
  ENGINEER: ["BIOMEDICAL_ENGINEER", "BIOMEDICAL_ENGINEERING_REPORT_ADMIN"],
  SERVICE_ORDER_MANAGEMENT: ["BIOMEDICAL_ENGINEER", "BIOMEDICAL_SERVICE_ORDER_ADMIN"],
  APPROVER_CREATOR_TECHNICAL_INSPECTION: [
    "BIOMEDICAL_INSPECTION_ADMIN",
    "BIOMEDICAL_INSPECTION_APPROVER",
  ],
  APPROVER_TECHNICAL_INSPECTION: ["BIOMEDICAL_INSPECTION_APPROVER"],
  RISK_AND_OPPORTUNNITY_MANAGER: ["RISK_AND_OPP_MODULE_ADMIN"],
  RISK_AND_OPP_ADMIN: ["RISK_AND_OPP_MODULE_ADMIN"],
  INTERESTED_PARTIES_MANAGER: ["INTERESTED_PARTIES_MODULE_ADMIN"],
  WALLET: ["SERALOGIN_WALLET_ACCESS"],
  WALLET_ADMIN: ["WALLET_MODULE_ADMIN"],
  SUPPLIER_MANAGER: ["SUPPLIERS_MODULE_ADMIN"],
  SUPPLIER_READER: ["SERALOGIN_SUPPLIERS_ACCESS"],
  ADMINISTRATIVE_MANAGEMENT_LEADER: [
    "SERALOGIN_PROCESS_LEADER_ADMINISTRATIVE_MANAGEMENT",
  ],
  BIOMEDICAL_MANAGEMENT_LEADER: [
    "SERALOGIN_PROCESS_LEADER_BIOMEDICAL_MANAGEMENT",
  ],
  COMMERCIAL_MANAGEMENT_LEADER: [
    "SERALOGIN_PROCESS_LEADER_COMMERCIAL_MANAGEMENT",
  ],
  HUMAN_RESOURCES_MANAGEMENT_LEADER: [
    "SERALOGIN_PROCESS_LEADER_HUMAN_RESOURCES_MANAGEMENT",
  ],
  HSQ_MANAGEMENT_LEADER: ["SERALOGIN_PROCESS_LEADER_HSQ_MANAGEMENT"],
  MARKETING_AND_PROMOTION_MANAGEMENT_LEADER: [
    "SERALOGIN_PROCESS_LEADER_MARKETING_AND_PROMOTION_MANAGEMENT",
  ],
  CUSTOMER_SERVICE_MANAGEMENT_LEADER: [
    "SERALOGIN_PROCESS_LEADER_CUSTOMER_SERVICE_MANAGEMENT",
  ],
  FINANCIAL_AND_ACCOUNTING_MANAGEMENT_LEADER: [
    "SERALOGIN_PROCESS_LEADER_FINANCIAL_AND_ACCOUNTING_MANAGEMENT",
  ],
  PHARMACEUTICAL_MANAGEMENT_LEADER: [
    "SERALOGIN_PROCESS_LEADER_PHARMACEUTICAL_MANAGEMENT",
  ],
  MANAGEMENT_DIRECTOR_LEADER: [
    "SERALOGIN_PROCESS_LEADER_MANAGEMENT_DIRECTION",
  ],
  FOREIGN_TRADE_DIRECTOR_LEADER: [
    "SERALOGIN_PROCESS_LEADER_FOREIGN_TRADE_DIRECTION",
  ],
  TECHNICAL_DIRECTION_TECHNICAL_SUPPORT_LEADER: [
    "SERALOGIN_PROCESS_LEADER_TECHNICAL_SUPPORT_DIRECTION",
  ],
  SAFETY_AND_HEALTH_AT_WORK_LEADER: [
    "SERALOGIN_PROCESS_LEADER_SAFETY_AND_HEALTH_AT_WORK",
  ],
  FOREIGN_TRADE_MANAGEMENT_LEADER: [
    "SERALOGIN_PROCESS_LEADER_FOREIGN_TRADE_MANAGEMENT",
  ],
  CUSTOMER_SERVICE_PHARMADIA_MANAGEMENT_LEADER: [
    "SERALOGIN_PROCESS_LEADER_CUSTOMER_SERVICE_PHARMADIA",
  ],
  RISK_AND_OPP_PROCESS_LEADER_ADMINISTRATIVE_MANAGEMENT: [
    "SERALOGIN_PROCESS_LEADER_ADMINISTRATIVE_MANAGEMENT",
  ],
  RISK_AND_OPP_PROCESS_LEADER_BIOMEDICAL_MANAGEMENT: [
    "SERALOGIN_PROCESS_LEADER_BIOMEDICAL_MANAGEMENT",
  ],
  RISK_AND_OPP_PROCESS_LEADER_COMMERCIAL_MANAGEMENT: [
    "SERALOGIN_PROCESS_LEADER_COMMERCIAL_MANAGEMENT",
  ],
  RISK_AND_OPP_PROCESS_LEADER_HUMAN_RESOURCES_MANAGEMENT: [
    "SERALOGIN_PROCESS_LEADER_HUMAN_RESOURCES_MANAGEMENT",
  ],
  RISK_AND_OPP_PROCESS_LEADER_HSQ_MANAGEMENT: [
    "SERALOGIN_PROCESS_LEADER_HSQ_MANAGEMENT",
  ],
  RISK_AND_OPP_PROCESS_LEADER_MARKETING_AND_PROMOTION_MANAGEMENT: [
    "SERALOGIN_PROCESS_LEADER_MARKETING_AND_PROMOTION_MANAGEMENT",
  ],
  RISK_AND_OPP_PROCESS_LEADER_CUSTOMER_SERVICE_MANAGEMENT: [
    "SERALOGIN_PROCESS_LEADER_CUSTOMER_SERVICE_MANAGEMENT",
  ],
  RISK_AND_OPP_PROCESS_LEADER_FINANCIAL_AND_ACCOUNTING_MANAGEMENT: [
    "SERALOGIN_PROCESS_LEADER_FINANCIAL_AND_ACCOUNTING_MANAGEMENT",
  ],
  RISK_AND_OPP_PROCESS_LEADER_PHARMACEUTICAL_MANAGEMENT: [
    "SERALOGIN_PROCESS_LEADER_PHARMACEUTICAL_MANAGEMENT",
  ],
  RISK_AND_OPP_PROCESS_LEADER_MANAGEMENT_DIRECTION: [
    "SERALOGIN_PROCESS_LEADER_MANAGEMENT_DIRECTION",
  ],
  RISK_AND_OPP_PROCESS_LEADER_FOREIGN_TRADE_DIRECTION: [
    "SERALOGIN_PROCESS_LEADER_FOREIGN_TRADE_DIRECTION",
  ],
  RISK_AND_OPP_PROCESS_LEADER_TECHNICAL_SUPPORT_DIRECTION: [
    "SERALOGIN_PROCESS_LEADER_TECHNICAL_SUPPORT_DIRECTION",
  ],
  RISK_AND_OPP_PROCESS_LEADER_SAFETY_AND_HEALTH_AT_WORK: [
    "SERALOGIN_PROCESS_LEADER_SAFETY_AND_HEALTH_AT_WORK",
  ],
  RISK_AND_OPP_PROCESS_LEADER_FOREIGN_TRADE_MANAGEMENT: [
    "SERALOGIN_PROCESS_LEADER_FOREIGN_TRADE_MANAGEMENT",
  ],
  RISK_AND_OPP_PROCESS_LEADER_CUSTOMER_SERVICE_PHARMADIA: [
    "SERALOGIN_PROCESS_LEADER_CUSTOMER_SERVICE_PHARMADIA",
  ],
  INTERESTED_PARTIES_LEADER_ADMINISTRATIVA: [
    "SERALOGIN_PROCESS_LEADER_ADMINISTRATIVE_MANAGEMENT",
  ],
  INTERESTED_PARTIES_LEADER_BIOMEDICA_DIRECCION_TECNICA: [
    "SERALOGIN_PROCESS_LEADER_BIOMEDICAL_MANAGEMENT",
  ],
  INTERESTED_PARTIES_LEADER_COMERCIAL: [
    "SERALOGIN_PROCESS_LEADER_COMMERCIAL_MANAGEMENT",
  ],
  INTERESTED_PARTIES_LEADER_HUMANA: [
    "SERALOGIN_PROCESS_LEADER_HUMAN_RESOURCES_MANAGEMENT",
  ],
  INTERESTED_PARTIES_LEADER_HSQ_CALIDAD: [
    "SERALOGIN_PROCESS_LEADER_HSQ_MANAGEMENT",
  ],
  INTERESTED_PARTIES_LEADER_MERCADEO_PROMOCION: [
    "SERALOGIN_PROCESS_LEADER_MARKETING_AND_PROMOTION_MANAGEMENT",
  ],
  INTERESTED_PARTIES_LEADER_SERVICIO_CLIENTE: [
    "SERALOGIN_PROCESS_LEADER_CUSTOMER_SERVICE_MANAGEMENT",
  ],
  INTERESTED_PARTIES_LEADER_FINANCIERA_CONTABLE: [
    "SERALOGIN_PROCESS_LEADER_FINANCIAL_AND_ACCOUNTING_MANAGEMENT",
  ],
  INTERESTED_PARTIES_LEADER_FARMACEUTICA: [
    "SERALOGIN_PROCESS_LEADER_PHARMACEUTICAL_MANAGEMENT",
  ],
  INTERESTED_PARTIES_LEADER_DIRECCION: [
    "SERALOGIN_PROCESS_LEADER_MANAGEMENT_DIRECTION",
  ],
  INTERESTED_PARTIES_LEADER_DIRECCION_COMERCIO_EXTERIOR: [
    "SERALOGIN_PROCESS_LEADER_FOREIGN_TRADE_DIRECTION",
  ],
  INTERESTED_PARTIES_LEADER_BIOMEDICA_SOPORTE_TECNICO: [
    "SERALOGIN_PROCESS_LEADER_TECHNICAL_SUPPORT_DIRECTION",
  ],
  INTERESTED_PARTIES_LEADER_HSQ_SST: [
    "SERALOGIN_PROCESS_LEADER_SAFETY_AND_HEALTH_AT_WORK",
  ],
  INTERESTED_PARTIES_LEADER_COMERCIO_EXTERIOR: [
    "SERALOGIN_PROCESS_LEADER_FOREIGN_TRADE_MANAGEMENT",
  ],
  INTERESTED_PARTIES_LEADER_SERVICIO_CLIENTE_PHARMADIA: [
    "SERALOGIN_PROCESS_LEADER_CUSTOMER_SERVICE_PHARMADIA",
  ],
  SERALOGIN_MARKETING_PROMOTION_ACCESS: ["MARKETING_PROMOTION_VIEWER"],
  TASK_MANAGER: ["TASK_MANAGER_MODULE_ADMIN"],
  TASK_MANAGER_ADMIN: ["TASK_MANAGER_MODULE_ADMIN", "TASK_MANAGER_TASK_ADMIN"],
  TASK_MANAGER_INDICATORS_VIEWER: ["TASK_MANAGER_INDICATORS_ADMIN"],
  TASK_MANAGER_ADMIN_JUSTIFIED_ACTIVITIES: [
    "TASK_MANAGER_JUSTIFIED_ACTIVITIES_ADMIN",
  ],
  TASK_MANAGER_ADMIN_ADMINISTRATIVA: [
    "TASK_MANAGER_PROCESS_LEADER_ADMINISTRATIVE_MANAGEMENT",
  ],
  TASK_MANAGER_ADMIN_BIOMEDICA: [
    "TASK_MANAGER_PROCESS_LEADER_BIOMEDICAL_MANAGEMENT",
  ],
  TASK_MANAGER_ADMIN_COMERCIAL: [
    "TASK_MANAGER_PROCESS_LEADER_COMMERCIAL_MANAGEMENT",
  ],
  TASK_MANAGER_ADMIN_HUMAN_GESTION: [
    "TASK_MANAGER_PROCESS_LEADER_HUMAN_RESOURCES_MANAGEMENT",
  ],
  TASK_MANAGER_ADMIN_HSQ: ["TASK_MANAGER_PROCESS_LEADER_HSQ_MANAGEMENT"],
  TASK_MANAGER_ADMIN_MERCADEO_PROMOCION: [
    "TASK_MANAGER_PROCESS_LEADER_MARKETING_AND_PROMOTION_MANAGEMENT",
  ],
  TASK_MANAGER_ADMIN_CLIENT_SERVICE: [
    "TASK_MANAGER_PROCESS_LEADER_CUSTOMER_SERVICE_MANAGEMENT",
  ],
  TASK_MANAGER_ADMIN_FINANCIERA_CONTABLE: [
    "TASK_MANAGER_PROCESS_LEADER_FINANCIAL_AND_ACCOUNTING_MANAGEMENT",
  ],
  TASK_MANAGER_ADMIN_FARMACEUTICA: [
    "TASK_MANAGER_PROCESS_LEADER_PHARMACEUTICAL_MANAGEMENT",
  ],
  TASK_MANAGER_ADMIN_COMERCIAL_EXTERIOR: [
    "TASK_MANAGER_PROCESS_LEADER_FOREIGN_TRADE_MANAGEMENT",
  ],
  TASK_MANAGER_ADMIN_CLIENT_SERVICE_PHARMADIA: [
    "TASK_MANAGER_PROCESS_LEADER_CUSTOMER_SERVICE_PHARMADIA",
  ],
  TASK_MANAGER_ASSIGNEE_ADMINISTRATIVA: [
    "TASK_MANAGER_PROCESS_COLLABORATOR_ADMINISTRATIVE_MANAGEMENT",
  ],
  TASK_MANAGER_ASSIGNEE_BIOMEDICA: [
    "TASK_MANAGER_PROCESS_COLLABORATOR_BIOMEDICAL_MANAGEMENT",
  ],
  TASK_MANAGER_ASSIGNEE_COMERCIAL: [
    "TASK_MANAGER_PROCESS_COLLABORATOR_COMMERCIAL_MANAGEMENT",
  ],
  TASK_MANAGER_ASSIGNEE_HUMAN_GESTION: [
    "TASK_MANAGER_PROCESS_COLLABORATOR_HUMAN_RESOURCES_MANAGEMENT",
  ],
  TASK_MANAGER_ASSIGNEE_HSQ: [
    "TASK_MANAGER_PROCESS_COLLABORATOR_HSQ_MANAGEMENT",
  ],
  TASK_MANAGER_ASSIGNEE_MERCADEO_PROMOCION: [
    "TASK_MANAGER_PROCESS_COLLABORATOR_MARKETING_AND_PROMOTION_MANAGEMENT",
  ],
  TASK_MANAGER_ASSIGNEE_CLIENT_SERVICE: [
    "TASK_MANAGER_PROCESS_COLLABORATOR_CUSTOMER_SERVICE_MANAGEMENT",
  ],
  TASK_MANAGER_ASSIGNEE_FINANCIERA_CONTABLE: [
    "TASK_MANAGER_PROCESS_COLLABORATOR_FINANCIAL_AND_ACCOUNTING_MANAGEMENT",
  ],
  TASK_MANAGER_ASSIGNEE_FARMACEUTICA: [
    "TASK_MANAGER_PROCESS_COLLABORATOR_PHARMACEUTICAL_MANAGEMENT",
  ],
  TASK_MANAGER_ASSIGNEE_COMERCIAL_EXTERIOR: [
    "TASK_MANAGER_PROCESS_COLLABORATOR_FOREIGN_TRADE_MANAGEMENT",
  ],
  TASK_MANAGER_ASSIGNEE_CLIENT_SERVICE_PHARMADIA: [
    "TASK_MANAGER_PROCESS_COLLABORATOR_CUSTOMER_SERVICE_PHARMADIA",
  ],
};

export function normalizeRoleId(role) {
  return String(role || "").trim().toUpperCase();
}

export function getCompatibleRoleIdsForCheck(role) {
  const normalizedRole = normalizeRoleId(role);
  return [
    normalizedRole,
    ...(LEGACY_CHECK_COMPATIBILITY[normalizedRole] || []),
  ];
}

export function isRoleUtil(role, roleArray = []) {
  const userRoles = new Set((roleArray || []).map(normalizeRoleId));
  return getCompatibleRoleIdsForCheck(role).some((candidate) =>
    userRoles.has(candidate)
  );
}

/**
 * True si el usuario tiene el rol objetivo, un alias compatible al pedirlo,
 * o un rol legacy que mapea hacia ese rol objetivo.
 */
export function hasEffectiveRole(roleArray = [], targetRole) {
  if (isRoleUtil(targetRole, roleArray)) return true;
  const normalizedTarget = normalizeRoleId(targetRole);
  const userRoles = (roleArray || []).map(normalizeRoleId);
  return userRoles.some((userRole) => {
    const mapped = LEGACY_CHECK_COMPATIBILITY[userRole] || [];
    return mapped.map(normalizeRoleId).includes(normalizedTarget);
  });
}

export function hasAnyRoleUtil(roles, roleArray = []) {
  return (roles || []).some((role) => isRoleUtil(role, roleArray));
}
